import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { EditUserProfile } from "views/foundation/user/Home/EditProfile/EditUserProfile";

/**
 * Edição do Perfil de usuário.
 * @param props
 */
const EditProfile: React.FC = () => {

    const { id } = useParams();

    const [userId, setUserId] = useState<string>(id!);

    useEffect(() => {
        if (id) setUserId(id);
    }, [id]);

    return (
        <EditUserProfile userId={userId} />
    );
};

export default EditProfile;